import { ExtendableError } from '@seneca/client-library';

export default class SchoolInfoBySchoolIdDoesNotExistError extends ExtendableError {
  schoolId: string;

  constructor(schoolId: string) {
    super(`School info does not exist for schoolId: ${schoolId}`);

    this.schoolId = schoolId;
  }
}
